module.exports = __webpack_public_path__ + "img/druid.8d720dc3.png";